import styled from 'styled-components';

export const ListItemAvatarStyled = styled.img`
  width: 120px;
  height: 80px;
  display: block;
  background-size: cover;
  background-position: center;
`;
